<template>
	<div class="radioComponent">
		<el-radio-group v-model="radioValue">
      <el-row>
        <el-col :span="siz" v-for="(item,index) in radioList" :key="index">
          <el-radio :label="item.value">{{item.name}}</el-radio>
        </el-col>
      </el-row>
		</el-radio-group>
	</div>
</template>

<script>
	export default{
		name: "RadioComponent",
		props: {
			value: {},
			radioList: Array,
		},
		computed:{
      siz() {
        if (this.radioList[0].name === "向左") return 12    // 特判是延伸方向时,划为一行两格展示
        else return 24
      },
			radioValue:{
				get() {
          return this.value
        },
        set(val) {
          this.$emit("input", val)
        }
			}
		}
	}
</script>

<style>
</style>
